import { ITheme } from '../types/themeInterface/index';
export type TSelect = 'popularity' | 'latest' | 'name';
export const popularityOrder = ['Motto', 'Essentials', 'Aesthetic', 'Nordic'];

const getFilteredData = (data: ITheme[], activeOption: TSelect) => {
  switch (activeOption) {
    case 'popularity':
      return data.slice().sort((a: ITheme, b: ITheme) => {
        return popularityOrder.indexOf(a.title!) - popularityOrder.indexOf(b.title!);
      });
    case 'latest':
      return data.slice().sort((a: ITheme, b: ITheme): number => {
        const dateA = new Date(a._createdAt!);
        const dateB = new Date(b._createdAt!);
        return dateB.getTime() - dateA.getTime();
      });
    case 'name':
      return data.slice().sort((a: ITheme, b: ITheme) => {
        return a.title!.localeCompare(b.title!);
      });
    default:
      return data;
  }
};

export { getFilteredData };
